import React, { useEffect, useState } from "react";
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, styled, IconButton, Select, MenuItem } from "@mui/material";
import { KeyboardArrowDown, KeyboardArrowRight } from "@mui/icons-material"; // For arrow icons
import KeyboardDoubleArrowDownIcon from "@mui/icons-material/KeyboardDoubleArrowDown";
import KeyboardDoubleArrowRightIcon from "@mui/icons-material/KeyboardDoubleArrowRight";
import { Checkbox } from "@mui/material";
import { Check } from "@mui/icons-material";
import { useSettingContext } from "context/SettingContext";
import RemoveModal from "components/ui/RemoveModal/RemoveModal";
import { getAllRoles, getSpecificRole } from "../Role/Apis/get-role";
import { convertBackednResponseToLocalStorageFormat, convertPayload, convertSavedDataToPayload, convertSavedRightsToPayload } from "./hooks/convertRights";
import { saveRights } from "./api/save-rights";
import { toast } from "react-toastify";
import { findSpecificMenu, findSpecificPage, findSpecificSubMenu, findSpecificSubPage, hasAccessSubPage, isAllowed } from "utils/checkUserRigths";
import { usePermissions } from "context/PermissionsContext";
import { ReactComponent as sahilbhai } from "../../../assets/icons/Arrowdown.svg";

const pageInfo = [
  {
    parentPage: "Catalog",
    parentRights: ["Add", "Edit", "View", "Archive"],
    childPages: [
      {
        childPageName: "Share Catalog",
        childPageRights: ["Add", "View"],
      },
      {
        childPageName: "Catalog Activity",
        childPageRights: ["View"],
      },
    ],
  },
  {
    parentPage: "Catalog Setting",
    parentRights: ["View"],
    childPages: [
      {
        childPageName: "Add Mobile No.",
        childPageRights: ["Add", "Edit", "View"],
      },
      {
        childPageName: "Bulk Mobile No. List",
        childPageRights: ["Add", "View"],
      },
      {
        childPageName: "Catalog Report",
        childPageRights: ["View"],
      },
      {
        childPageName: "Client Report",
        childPageRights: ["View"],
      },
    ],
  },
  {
    parentPage: "Client Activity",
    parentRights: ["View"],
    childPages: [
      {
        childPageName: "Renew & Revoke Access",
        childPageRights: ["Add", "View", "Archive"],
      },
    ],
  },
  {
    parentPage: "Category",
    parentRights: ["Edit", "View"],

    childPages: [
      {
        childPageName: "Design Class",
        childPageRights: ["Edit"],
      },
      {
        childPageName: "Move Sub-Category",
        childPageRights: ["Edit"],
      },
      {
        childPageName: "Make Type",
        childPageRights: ["Edit"],
      },
      {
        childPageName: "Restrict Design",
        childPageRights: ["Edit"],
      },
    ],
  },
  {
    parentPage: "Collection",
    parentRights: ["Edit", "View", "Add", "Archive"],
    childPages: [
      {
        childPageName: "Name Change",
        childPageRights: ["Edit", "View"],
      },
      {
        childPageName: "Description",
        childPageRights: ["Edit", "View"],
      },
    ],
  },
  {
    parentPage: "AI Collection",
    parentRights: ["View"],
    childPages: [
      {
        childPageName: "Top 30 Sold - 30 Days",
        childPageRights: ["View"],
      },
      {
        childPageName: "Top 60 Sold - 60 Days",
        childPageRights: ["View"],
      },
      {
        childPageName: "Top 90 Sold - 90 Days",
        childPageRights: ["View"],
      },
      {
        childPageName: "New 30 Sold - 30 Days",
        childPageRights: ["View"],
      },
      {
        childPageName: "New 60 Sold - 60 Days",
        childPageRights: ["View"],
      },
      {
        childPageName: "New 90 Sold - 90 Days",
        childPageRights: ["View"],
      },
      {
        childPageName: "CAD Designs",
        childPageRights: ["View"],
      },
      {
        childPageName: "Duplicate Stocks",
        childPageRights: ["View"],
      },
      {
        childPageName: "Restricted Stocks",
        childPageRights: ["View"],
      },
      {
        childPageName: "1 to 2 years Old Stock",
        childPageRights: ["View"],
      },
      {
        childPageName: "2 to 3 years Old Stock",
        childPageRights: ["View"],
      },
      {
        childPageName: "3 to 4 years Old Stock",
        childPageRights: ["View"],
      },
      {
        childPageName: "4 to 5 years Old Stock",
        childPageRights: ["View"],
      },
      {
        childPageName: "5 to 6 years Old Stock",
        childPageRights: ["View"],
      },
      {
        childPageName: "6 to 7 years Old Stock",
        childPageRights: ["View"],
      },
      {
        childPageName: "Binny's Select Designs",
        childPageRights: ["View"],
      },
      {
        childPageName: "New Design Out of Stock",
        childPageRights: ["View"],
      },
      {
        childPageName: "1-2 Years Design Out of stock",
        childPageRights: ["View"],
      },
      {
        childPageName: "2-3 Years Design Out of stock",
        childPageRights: ["View"],
      },
      {
        childPageName: "Under Ratio Designs",
        childPageRights: ["View"],
      },
      {
        childPageName: "Over Ratio Diamond",
        childPageRights: ["View"],
      },
    ],
  },
  {
    parentPage: "Sets",
    parentRights: ["Add", "Edit", "View", "Archive"],
    // childPages: [
    //   {
    //     childPageName: "Design Collection",
    //     childPageRights: ["View"],
    //   },
    // ],
  },
  {
    parentPage: "Stock",
    parentRights: ["View"],
  },
  {
    parentPage: "Settings",
    parentRights: ["View"],
    childPages: [
      {
        childPageName: "Roles",
        childPageRights: ["Add", "Edit", "View", "Archive"],
      },
      {
        childPageName: "User",
        childPageRights: ["Add", "Edit", "View", "Archive"],
      },
      {
        childPageName: "Main Activity",
        childPageRights: ["View"],
      },
      {
        childPageName: "Profile",
        childPageRights: ["Edit", "View"],
      },
      {
        childPageName: "Archives",
        childPageRights: ["Edit", "View", "Archive"],
      },
      {
        childPageName: "Rights",
        childPageRights: ["Edit", "View"],
      },
      {
        childPageName: "Limits",
        childPageRights: ["Edit", "View"],
      },
      {
        childPageName: "Orders",
        childPageRights: ["View"],
      },
      {
        childPageName: "Restricted Designs",
        childPageRights: ["Edit", "View"],
      },
    ],
  },
  {
    parentPage: "Other Settings",
    parentRights: ["View"],
    childPages: [
      {
        childPageName: "Design Date",
        childPageRights: ["View"],
      },
      {
        childPageName: "Screenshots",
        childPageRights: ["View"],
      },
      {
        childPageName: "Watermark",
        childPageRights: ["View"],
      },
      {
        childPageName: "Missing Images",
        childPageRights: ["View"],
      },
      {
        childPageName: "Web Accessibility",
        childPageRights: ["View"],
      },
      {
        childPageName: "Mobile Accessibility",
        childPageRights: ["View"],
      },
    ],
  },
  {
    parentPage: "Sales Count",
    parentRights: ["View"],
    childPages: [
      {
        childPageName: "Sales By Year",
        childPageRights: ["View"],
      },
      {
        childPageName: "Sales By Client",
        childPageRights: ["View"],
      },
      {
        childPageName: "Highest Seller Trophy",
        childPageRights: ["View"],
      },
      {
        childPageName: "Best Seller Border",
        childPageRights: ["View"],
      },
    ],
  },
  {
    parentPage: "Sync",
    parentRights: ["Edit", "View"],
    childPages: [
      {
        childPageName: "Sub-Category",
        childPageRights: ["Edit", "View"],
      },
      {
        childPageName: "Make Type",
        childPageRights: ["Edit", "View"],
      },
      {
        childPageName: "Design Restriction",
        childPageRights: ["Edit", "View"],
      },
      {
        childPageName: "Design Class",
        childPageRights: ["Edit", "View"],
      },
      {
        childPageName: "Revert Changes",
        childPageRights: ["Edit", "View"],
      },
    ],
  },
  {
    parentPage: "Binny’s Select",
    parentRights: ["Add", "View", "Level"],
    childPages: [
      {
        childPageName: "E-mail & Whatsapp",
        childPageRights: ["Add", "View"],
      },
    ],
  },
  {
    parentPage: "My Binny’s App",
    parentRights: ["Add", "Edit", "View", "Archive"],
  },
  {
    parentPage: "Binny’s Scan App",
    parentRights: ["View"],
  },
  {
    parentPage: "Clients",
    parentRights: ["View"],
    childPages: [
      {
        childPageName: "Purchases",
        childPageRights: ["View"],
      },
      {
        childPageName: "Catalog",
        childPageRights: ["View"],
      },
      {
        childPageName: "Dues & Ledger",
        childPageRights: ["View"],
      },
      {
        childPageName: "Quotes & Orders",
        childPageRights: ["View"],
      },
      {
        childPageName: "WIP",
        childPageRights: ["View"],
      },
      {
        childPageName: "NPD Orders",
        childPageRights: ["View"],
      },
      {
        childPageName: "Service Request",
        childPageRights: ["View"],
      },
      {
        childPageName: "Request Visit",
        childPageRights: ["View"],
      },
    ],
  },
];

//-------------------------------------- Style ------------------------------------\\

const StyledTableContainer = styled(TableContainer)(({}) => ({
  backgroundColor: "transparent",
  border: "1px solid #fff",
  borderRadius: "5px",
  maxHeight: "71vh",
  overflow: "auto",
  background: "#000",
  "&::-webkit-scrollbar": {
    width: 0,
    height: 0,
  },
  "&": {
    scrollbarWidth: "none",
    msOverflowStyle: "none",
  },
}));

const StyledTable = styled(Table)(({}) => ({
  "& th, & td": {
    fontSize: "18px",
    fontFamily: "karla",
    fontWeight: 500,
    lineHeight: "22px",
    color: "#FFFFFF",
    textAlign: "center",
  },
  "& th": {
    backgroundColor: "#444444",
  },
}));

const StyledTableHeaderCell = styled(TableCell)(({}) => ({
  fontFamily: "Poppins",
  padding: "10px",
  border: "none",
  fontSize: "14px !important",
  fontWeight: "400 !important",
  backgroundColor: "#fff",

  "&:last-child": {
    paddingRight: "25px",
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  borderBottom: "1px solid #fff",

  "& td": {
    paddingTop: "0px ",
    paddingBottom: "0px ",
  },
}));

const StyledTableBodyCell = styled(TableCell)(({ theme }) => ({
  fontFamily: "Karla",
  padding: "10px",
  paddingLeft: "15px",
  paddingRight: "15px",
  border: "none", // Remove border to ensure only row borders are visible
  "&::first-of-type": {
    paddingLeft: "5px",
  },
  "&:last-child": {
    paddingRight: "20px",
  },
}));

const CustomUncheckedIcon = styled("span")(({ theme, disabled }) => ({
  width: 24,
  height: 24,
  borderRadius: 5, // Rounded corners
  backgroundColor: disabled ? "#A9A9A9" : "transparent", // Background color for unchecked state
  border: "1px solid #ccc", // Border for unchecked state
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  opacity: disabled ? 0.6 : 1,
}));

const CustomCheckedIcon = styled("span")(({ theme, disabled }) => ({
  width: 24,
  height: 24,
  borderRadius: 5,
  backgroundColor: disabled ? "#A9A9A9" : "#50C878",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  color: "#fff",
  opacity: disabled ? 0.6 : 1,
}));

//-------------------------------------- Style ------------------------------------\\

function RightPage() {
  const [expandedPage, setExpandedPage] = useState(null);
  const [checkedRights, setCheckedRights] = useState([]);

  const [isAdmin, setIsAdmin] = useState(false);
  const { setIsRightPage, setSelectRoleOptions, setEnableSaveRightsBtn, selectRoleBtnName, setVibrateButton, setSelectRoleBtnName, saveRightModalOpen, setSaveRightModalOpen } = useSettingContext();

  const permission = usePermissions();

  
  const hasAccessToEditRights = isAllowed(findSpecificSubMenu(findSpecificMenu("Vision Web", permission), "Rights"), "edit");
  // const hasAccessEditRights = hasAccessSubPage(findSpecificSubPage(findSpecificPage("Settings", permission), "Rights"), "edit");

  const handleCheckboxChange = (page, right, isParent, parentPage) => {
    setCheckedRights((prevState) => {
      const updatedRights = [...prevState];

      const pageIndex = updatedRights.findIndex((item) => item.page === page && item.parent === parentPage);
      const newRightState = pageIndex !== -1 ? !updatedRights[pageIndex].rights[right] : true;

      if (pageIndex !== -1) {
        updatedRights[pageIndex] = {
          ...updatedRights[pageIndex],
          rights: {
            ...updatedRights[pageIndex].rights,
            [right]: newRightState,
          },
          parent: parentPage,
        };
      } else {
        updatedRights.push({
          page,
          rights: {
            [right]: true,
          },
          parent: parentPage,
        });
      }

      if (isParent) {
        const parentPageData = findParentPageData(page);
        if (parentPageData) {
          parentPageData?.childPages?.forEach((child) => {
            const childPageIndex = updatedRights.findIndex((item) => item.page === child.childPageName && item.parent === parentPage);
            if (child?.childPageRights?.includes(right)) {
              if (childPageIndex !== -1) {
                updatedRights[childPageIndex] = {
                  ...updatedRights[childPageIndex],
                  rights: {
                    ...updatedRights[childPageIndex].rights,
                    [right]: newRightState,
                  },
                  parent: parentPageData.parentPage,
                };
              } else {
                updatedRights.push({
                  page: child?.childPageName,
                  rights: {
                    [right]: newRightState,
                  },
                  parent: parentPageData.parentPage,
                });
              }
            }
          });
        } else {
          // Mark the parent page checked if this is a child page
          const parentPageData = findParentPageDataByChild(page, parentPage); // Create this utility to find parent by child

          if (parentPageData) {
            const parentPageIndex = updatedRights.findIndex((item) => item.page === parentPageData.parentPage);
            if (parentPageIndex !== -1) {
              updatedRights[parentPageIndex] = {
                ...updatedRights[parentPageIndex],
                rights: {
                  ...updatedRights[parentPageIndex].rights,
                  [right]: true, // Ensure the parent's right is checked
                },
                parent: parentPageData.parentPage,
              };
            } else {
              // Not Tested
              alert("Not Tested");
              updatedRights.push({
                page: parentPageData.parentPage,
                rights: {
                  [right]: true,
                },
              });
            }
          }
        }
      }

      const shouldEnableSaveRightsBtn = selectRoleBtnName !== "Select Role" && updatedRights.some((pageItem) => Object.values(pageItem.rights).some((rightChecked) => rightChecked));
      setEnableSaveRightsBtn(shouldEnableSaveRightsBtn);

      // Save to localStorage
      const savedRights = JSON.parse(localStorage.getItem("savedRights")) || [];

      const roleIndex = savedRights.findIndex((role) => role.RoleName === selectRoleBtnName);

      if (roleIndex !== -1) {
        savedRights[roleIndex].CheckedRights = updatedRights;
      } else {
        savedRights.push({
          RoleName: selectRoleBtnName,
          CheckedRights: updatedRights,
        });
      }

      localStorage.setItem("savedRights", JSON.stringify(savedRights));
      return updatedRights;
    });
  };

  const handleLevelChange = (page, right, value, parentPage) => {
    setCheckedRights((prevState) => {
      const updatedRights = [...prevState];

      const pageIndex = updatedRights.findIndex((item) => item.page === page && item.parent === parentPage);

      if (pageIndex !== -1) {
        updatedRights[pageIndex] = {
          ...updatedRights[pageIndex],
          rights: {
            ...updatedRights[pageIndex].rights,
            [right]: value,
            View: value === "all" || value === "own" || value === "none",
          },
          parent: parentPage,
        };
      } else {
        updatedRights.push({
          page,
          rights: {
            [right]: value,
            View: value === "all" || value === "own" || value === "none",
          },
          parent: parentPage,
        });
      }

      // Update localStorage and enable save button
      const shouldEnableSaveRightsBtn =
        selectRoleBtnName !== "Select Role" && updatedRights.some((pageItem) => Object.entries(pageItem.rights).some(([key, val]) => (key === "Level" ? val !== "none" : val === true)));
      setEnableSaveRightsBtn(shouldEnableSaveRightsBtn);

      const savedRights = JSON.parse(localStorage.getItem("savedRights")) || [];
      const roleIndex = savedRights.findIndex((role) => role.RoleName === selectRoleBtnName);

      if (roleIndex !== -1) {
        savedRights[roleIndex].CheckedRights = updatedRights;
      } else {
        savedRights.push({
          RoleName: selectRoleBtnName,
          CheckedRights: updatedRights,
        });
      }

      localStorage.setItem("savedRights", JSON.stringify(savedRights));

      return updatedRights;
    });
  };

  const findParentPageDataByChild = (childPageName, parentPage) => {
    return pageInfo.find((page) => page.childPages?.some((child) => child.childPageName === childPageName && page.parentPage === parentPage));
  };

  // Function to find parent page data based on the page name
  const findParentPageData = (pageName) => {
    return pageInfo.find((page) => page.parentPage === pageName);
  };

  const isRightChecked = (page, right, parentPage) => {
    // Find the exact page entry in checkedRights that matches both page and parentPage
    const pageRights = checkedRights.find((item) => item.page === page && item.parent === parentPage);

    // Ensure we're checking the right within the correct page
    return pageRights?.rights?.[right] || false;
  };

  const getCurrentLevelValue = (page, right, parentPage) => {
    const pageData = checkedRights.find((item) => item.page === page && item.parent === parentPage);

    return pageData?.rights?.[right] || "none";
  };

  // Render the checkbox or dropdown
  const renderCheckboxOrNA = (page, right, allowedRights, parentPage) => {
    const isChecked = isRightChecked(page, right, parentPage);

    const handleCheckboxClick = () => {
      if (selectRoleBtnName === "Select Role") {
        setVibrateButton(true);
        return;
      }
    };

    if (right === "Level") {
      const currentLevel = getCurrentLevelValue(page, right, parentPage);

      return (
        <Select
          value={currentLevel || "none"}
          onChange={(e) => {
            if (selectRoleBtnName === "Select Role") {
              setVibrateButton(true);
              return;
            } else {
              handleLevelChange(page, right, e.target.value, parentPage);
            }
          }}
          size="small"
          sx={{
            position: "relative",
            paddingleft: "25px",
            minWidth: 140,
            border: "0px",
            "& .MuiOutlinedInput-notchedOutline": {
              border: "none",
            },
            "& .MuiSelect-select": {
              display: "flex",
              alignItems: "center",
              justifyContent: "space-around",
            },
            "& .MuiSelect-icon": {
              right: "25%",
              top: "35%",
              color: "#000000",
              transition: "transform 0.2s ease-in-out",
              cursor: "pointer",
              position: "absolute",
              "&.Mui-expanded": {
                transform: "rotate(180deg)",
              },
            },
            "& .MuiSelect-select:focus": {
              backgroundColor: "transparent",
            },
          }}
          disabled={isAdmin || !hasAccessToEditRights}
          IconComponent={sahilbhai}
          MenuProps={{
            PaperProps: {
              sx: {
                padding: "0px 5px",
                marginTop: "3px",
                backgroundColor: "#FFFFFF",
                color: "#000000",
                borderRadius: "5px",
                maxHeight: "180px",
                maxWidth: "400px",
                overflowX: "scroll",
                "&::-webkit-scrollbar": {
                  width: "0px",
                },
                "&::-webkit-scrollbar-thumb": {
                  background: "transparent",
                },
                scrollbarWidth: "none",
                "& .MuiList-root": {
                  "& .MuiMenuItem-root": {
                    margin: "2px",
                    display: "flex",
                    justifyContent: "center",
                    alignContent: "center",
                    overflow: "visible",
                    whiteSpace: "normal",
                    paddingLeft: "10px",
                    paddingRight: "5px",
                    "&:hover": {
                      backgroundColor: "#444444",
                      color: "#FFFFFF",
                      borderRadius: "5px",
                      margin: "2px",
                      paddingLeft: "10px",
                      paddingRight: "2px",
                    },
                  },
                },
              },
            },
          }}
        >
          <MenuItem value="none">None</MenuItem>
          <MenuItem value="own">Own</MenuItem>
          <MenuItem value="all">All</MenuItem>
        </Select>
      );
    }

    return allowedRights?.includes(right) ? (
      <Checkbox
        disableRipple
        disabled={isAdmin || !hasAccessToEditRights}
        checked={isAdmin ? (page === "Watermark" ? false : true) : isChecked}
        onChange={() => {
          if (selectRoleBtnName !== "Select Role") {
            handleCheckboxChange(page, right, true, parentPage);
          } else {
            handleCheckboxClick();
          }
        }}
        icon={<CustomUncheckedIcon disabled={isAdmin && page === "Watermark"} />}
        checkedIcon={
          <CustomCheckedIcon disabled={isAdmin || !hasAccessToEditRights}>
            <Check style={{ fontSize: 18 }} />
          </CustomCheckedIcon>
        }
      />
    ) : (
      "N/A"
    );
  };

  useEffect(() => {
    const fetchRoles = async () => {
      setIsRightPage(true);
      try {
        const roles = await getAllRoles();
        setSelectRoleOptions(roles.data);
      } catch (error) {
        console.error("Error fetching roles:", error);
      }
    };

    fetchRoles();

    return () => {
      setIsRightPage(false);
      setSelectRoleOptions([]);
      setSelectRoleBtnName("");
      setCheckedRights([]);
      setEnableSaveRightsBtn(false);
      setVibrateButton(false);
      localStorage.removeItem("savedRights");
    };
  }, []);

  const [allExpanded, setAllExpanded] = useState(false);

  const toggleAccordion = (page) => {
    setExpandedPage((prevExpanded) => (prevExpanded === page ? null : page));
  };

  const toggleAllAccordions = () => {
    if (allExpanded) {
      setExpandedPage(null); // Collapse all
    } else {
      setExpandedPage("ALL"); // Expand all
    }
    setAllExpanded(!allExpanded);
  };

  const handleDiscardRights = async () => {
    // const roles = await getAllRoles();
    const role = await getSpecificRole(selectRoleBtnName);

    // setSelectRoleOptions(role.data);
    setEnableSaveRightsBtn(false);
    setSaveRightModalOpen(false);

    // const apiRole = roles.data.find((role) => role.roleName === selectRoleBtnName);

    let checkConvertedData = convertBackednResponseToLocalStorageFormat(role.data, pageInfo);

    if (checkConvertedData) {
      setCheckedRights(checkConvertedData.CheckedRights);
      setIsAdmin(checkConvertedData.isAdmin);
    }

    localStorage.removeItem("savedRights");
  };

  const handleSaveRights = async () => {
    const rightsToSave = [
      {
        RoleName: selectRoleBtnName,
        CheckedRights: checkedRights.map((item) => ({
          page: item.page,
          rights: item.rights,
          parent: item.parent,
        })),
      },
    ];

    const existingRights = JSON.parse(localStorage.getItem("savedRights")) || [];

    const existingRoleIndex = existingRights.findIndex((role) => role.RoleName === selectRoleBtnName);

    if (existingRoleIndex !== -1) {
      // If the role exists, update its rights
      existingRights[existingRoleIndex] = rightsToSave[0];
    } else {
      // If the role doesn't exist, add the new role to the array
      existingRights.push(rightsToSave[0]);
    }

    // Save the updated list to localStorage
    localStorage.setItem("savedRights", JSON.stringify(existingRights));

    //---------------- here after saving this to localstorage , convert that stored data in required format and then send it to payload call api ------------\\
    // Convert the saved rights to the payload format
    const convertedPayload = convertSavedRightsToPayload(pageInfo);

    //--------------

    const selectedRoleData = convertedPayload.find((role) => role.roleName === selectRoleBtnName);

    if (selectedRoleData) {
      let response = await saveRights(selectedRoleData);
      if (response.status === 200) {
        setEnableSaveRightsBtn(false);
        setSaveRightModalOpen(false);
        localStorage.removeItem("savedRights");
        toast.success(response.message, {
          autoClose: 1000,
          hideProgressBar: false,
        });
      } else {
        alert("Something went wrong !");
      }
      // window.location.reload(); // for refresh the page
    } else {
      console.error("Role not found in convertedPayload for selected role:", selectRoleBtnName);
    }
  };

  const btnInfo1 = [
    {
      btnName: "Discard Rights",
      bgColor: "#E77B7B",
      click: () => {
        handleDiscardRights();
      },
    },
    {
      btnName: "Save Rights",
      bgColor: "#50c878",
      click: () => {
        handleSaveRights();
      },
    },
  ];

  useEffect(() => {
    const fetchRoles1 = async (selectRoleBtnName) => {
      try {
        // const savedRights = JSON.parse(localStorage.getItem("savedRights")) || [];

        // const roleData = savedRights.find((role) => role.RoleName === selectRoleBtnName);

        const role = await getSpecificRole(selectRoleBtnName);

        // You can implement logic here to handle the data fetched from API

        // const apiRole = roles.data.find((role) => role.roleName === selectRoleBtnName);

        let checkConvertedData = convertBackednResponseToLocalStorageFormat(role.data, pageInfo);

        if (checkConvertedData) {
          setCheckedRights(checkConvertedData.CheckedRights);
          setIsAdmin(checkConvertedData.isAdmin);
        } else {
          setCheckedRights([]);
          setIsAdmin(false);
        }
      } catch (error) {
        console.error("Error fetching roles from API", error);
        setCheckedRights([]);
        setIsAdmin(false);
      }
    };

    // Call the function
    if (selectRoleBtnName !== "Select Role") {
      fetchRoles1(selectRoleBtnName);
    }
  }, [selectRoleBtnName]);

  //Note :- Need to remove all rights of taht respective role from local storage when user clcik on Discard (Not Mentioned yet )

  useEffect(() => {
    if (expandedPage === null) setAllExpanded(false);
  }, [expandedPage]);

  //this is a testing change

  return (
    <>
      <div className="Grid-padding" style={{ marginTop: "15px", marginLeft: "6px", marginRight: "11.5px" }}>
        {pageInfo.length ? (
          <StyledTableContainer>
            <StyledTable>
              <TableHead sx={{ position: "sticky", top: "0", zIndex: "1" }}>
                <TableRow>
                  <StyledTableHeaderCell style={{ width: "10px" }}>
                    <IconButton disableRipple onClick={toggleAllAccordions}>
                      {allExpanded ? <KeyboardDoubleArrowDownIcon /> : <KeyboardDoubleArrowRightIcon />}
                    </IconButton>
                  </StyledTableHeaderCell>
                  <StyledTableHeaderCell style={{ width: "270px" }}>Menu</StyledTableHeaderCell>
                  <StyledTableHeaderCell>Add</StyledTableHeaderCell>
                  <StyledTableHeaderCell>Edit</StyledTableHeaderCell>
                  <StyledTableHeaderCell>View</StyledTableHeaderCell>
                  <StyledTableHeaderCell>Archive</StyledTableHeaderCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {pageInfo.map((page, index) => (
                  <React.Fragment key={`parent-${index}`}>
                    <StyledTableRow>
                      <StyledTableBodyCell>
                        {page.childPages ? (
                          <IconButton disableRipple onClick={() => toggleAccordion(page.parentPage)}>
                            {expandedPage === "ALL" || expandedPage === page.parentPage ? <KeyboardArrowDown /> : <KeyboardArrowRight />}
                          </IconButton>
                        ) : (
                          ""
                        )}
                      </StyledTableBodyCell>
                      <StyledTableBodyCell>{page.parentPage}</StyledTableBodyCell>
                      <StyledTableBodyCell>{renderCheckboxOrNA(page.parentPage, "Add", page.parentRights, page.parentPage)}</StyledTableBodyCell>
                      <StyledTableBodyCell>{renderCheckboxOrNA(page.parentPage, "Edit", page.parentRights, page.parentPage)}</StyledTableBodyCell>
                      <StyledTableBodyCell>{renderCheckboxOrNA(page.parentPage, page.parentPage === "Binny’s Select" ? "Level" : "View", page.parentRights, page.parentPage)}</StyledTableBodyCell>
                      {/* <StyledTableBodyCell>{renderCheckboxOrNA(page.parentPage, "View", page.parentRights, page.parentPage)}</StyledTableBodyCell> */}
                      <StyledTableBodyCell>{renderCheckboxOrNA(page.parentPage, "Archive", page.parentRights, page.parentPage)}</StyledTableBodyCell>
                    </StyledTableRow>

                    {/* Render Child Pages when Accordion is expanded */}
                    {(expandedPage === "ALL" || expandedPage === page.parentPage) &&
                      page.childPages &&
                      page.childPages.map((childPage, childIndex) => (
                        <StyledTableRow key={`child-${index}-${childIndex}`}>
                          <StyledTableBodyCell></StyledTableBodyCell>
                          <StyledTableBodyCell sx={{ padding: "2px" }}>{childPage.childPageName}</StyledTableBodyCell>
                          <StyledTableBodyCell>{renderCheckboxOrNA(childPage.childPageName, "Add", childPage.childPageRights, page.parentPage)}</StyledTableBodyCell>
                          <StyledTableBodyCell>{renderCheckboxOrNA(childPage.childPageName, "Edit", childPage.childPageRights, page.parentPage)}</StyledTableBodyCell>
                          <StyledTableBodyCell>{renderCheckboxOrNA(childPage.childPageName, "View", childPage.childPageRights, page.parentPage)}</StyledTableBodyCell>
                          <StyledTableBodyCell>{renderCheckboxOrNA(childPage.childPageName, "Archive", childPage.childPageRights, page.parentPage)}</StyledTableBodyCell>
                        </StyledTableRow>
                      ))}
                  </React.Fragment>
                ))}
              </TableBody>
            </StyledTable>
          </StyledTableContainer>
        ) : (
          <div style={{ textAlign: "center", padding: "35px" }}>Home</div>
        )}
      </div>

      {saveRightModalOpen && <RemoveModal open={saveRightModalOpen} setOpen={setSaveRightModalOpen} btnInfo={btnInfo1} heading="Confirm granting this role these rights?" />}
    </>
  );
}

export default RightPage;
